import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, WithdrawAccountDialogueHandler } from './types';
import WithdrawAccountDialogueContext from './WithdrawAccountContext';

const { ConfirmationDialogue } = vp;

type WithdrawAccountDialogueProps = {
  handleDialogue: DialogueHandler<WithdrawAccountDialogueHandler>;
};

type FC = FunctionComponent<WithdrawAccountDialogueProps>;

const WithdrawAccountDialogue: FC = ({ handleDialogue }: WithdrawAccountDialogueProps) => {
  const { showWithdrawAccountErrorAlert, withdrawAccountError } = useContext(WithdrawAccountDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* EFT Withdraw Error */}
        <ConfirmationDialogue
          isVisible={showWithdrawAccountErrorAlert}
          title="Error! The transaction was not completed."
          status="error"
          subTitle={`${withdrawAccountError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showWithdrawAccountErrorAlert, withdrawAccountError],
  );
};

export default WithdrawAccountDialogue;
